import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold mb-2" }, "Días de visita", -1)
const _hoisted_2 = { class: "row my-3" }
const _hoisted_3 = { class: "col-md-6 col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold mb-2" }, "Horario de inicio", -1)
const _hoisted_5 = { class: "col-md-6 col-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold mb-2" }, "Horario de cierre", -1)
const _hoisted_7 = { class: "grid-content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold mb-2" }, "Duración de las citas", -1)
const _hoisted_9 = { class: "grid-content" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold mb-2" }, "Cupos por cita", -1)
const _hoisted_11 = { class: "d-flex flex-row justify-content-center mt-8" }
const _hoisted_12 = { class: "me-3 mb-3 mb-md-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Descartar", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label fs-base" }, " Guardar Cambios ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress fs-base" }, [
  /*#__PURE__*/_createTextVNode(" Creando configuración ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

import { reactive, ref, onMounted, watch } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useStore } from "vuex";
import moment from "moment";
import ApiService from "@/core/services/ApiService";
import { useRoute, useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'FormSale',
  props: ['change'],
  emits: ["closeModal"],
  setup(__props, { emit }) {

const props = __props;

const store = useStore();
const user = JSON.parse(localStorage.getItem("user"));
const userinfo = JSON.parse(localStorage.getItem("userinfo"));
const formSize = ref("default");
const ruleFormRef = ref<FormInstance>();
const btnCreateConfigurationSchule = ref<null | HTMLElement>(null);
const agencia: any = localStorage.getItem("agencyIdSelected");
const days = ref<any>([]);
const router = useRouter();
// eslint-disable-next-line no-undef

const ruleForm = reactive({
  days: [],
  appointmenttime: "",
  quotas: 1,
  start_time: "",
  end_time: "",
});
const idConfig = ref<any>(null);
const updateConfig = ref<boolean>(false);
const rules = reactive<FormRules>({
  days: [
    {
      type: "array",
      required: true,
      message: "Al menos se debe elegir un día",
      trigger: "change",
    },
  ],
  appointmenttime: [
    {
      required: true,
      message: "El horario de cita es obligatorio",
      trigger: "change",
    },
  ],
  quotas: [
    {
      required: true,
      message: "Este campo es obligatorio",
      trigger: "change",
    },
  ],
  start_time: [
    {
      required: true,
      message: "Selecciona un horario de inicio.",
      trigger: "change",
    },
  ],
  end_time: [
    {
      required: true,
      message: "Selecciona un horario de cierre.",
      trigger: "change",
    },
  ],
});

const appointmenttime_options = [
  {
    value: "30",
    label: "30 minutos",
  },
  {
    value: "45",
    label: "45 minutos",
  },
  {
    value: "60",
    label: "1 hora",
  },
];
days.value = [
  {
    label: "D",
    day: "Domingo",
    active: 0,
    id: 0,
  },
  {
    label: "L",
    day: "Lunes",
    active: 0,
    id: 1,
  },
  {
    label: "M",
    day: "Martes",
    active: 0,
    id: 2,
  },
  {
    label: "MI",
    day: "Miércoles",
    active: 0,
    id: 3,
  },
  {
    label: "J",
    day: "Jueves",
    active: 0,
    id: 4,
  },
  {
    label: "V",
    day: "Viernes",
    active: 0,
    id: 5,
  },
  {
    label: "S",
    day: "Sábado",
    active: 0,
    id: 6,
  },
];



watch(() => props.change, async (newValue: Props['change']) => {
  const { data } = await axios.get(process.env.VUE_APP_API_URL + "/api/get-current-agency");
  let currencyAgencyId = 0;
  if(data.data.id != undefined && data.data.id != null){
    currencyAgencyId = data.data.id;
    getConfig(currencyAgencyId);
  }
});

const sendrequest = async (url, data, formEl) => {
  btnCreateConfigurationSchule.value.disabled = true;
  btnCreateConfigurationSchule.value.setAttribute("data-kt-indicator", "on");
  try {
    var response: any = null;
    if (updateConfig.value != false) {
      response = await axios.put(url, data);
    } else {
      response = await axios.post(url, data);
    }
    if (response.data.success == true) {
      resetForm(formEl);
      Swal.fire({
        icon: "success",
        text: "Se guardó correctamente la configuración",
        buttonsStyling: false,
        confirmButtonText: "Aceptar",
        allowOutsideClick: false,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      }).then(() => {
        getConfig();
        router.go(0);
      });
    }
  } catch (error: any) {
    Swal.fire({
      text:
        typeof error.response.data.errors === "object"
          ? Object.values(error.response.data.errors).toString().replace(",", "</br>")
          : error.response.data.message,
      icon: "error",
    }).then(() => {
      emit("closeModal");
    });
  }
  btnCreateConfigurationSchule.value.disabled = false;
  btnCreateConfigurationSchule.value.removeAttribute("data-kt-indicator");
};

const getCurrentId = async () => {
  const { data } = await axios.get(process.env.VUE_APP_API_URL + "/api/get-current-agency");
  let currencyAgencyId = 0;
  if(data.data.id != undefined && data.data.id != null){
    currencyAgencyId = data.data.id;
  }
  return currencyAgencyId;
};

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      let url = process.env.VUE_APP_API_URL + "/api/schedules/agencies";
      const data = { ...ruleForm };
      let configDays: any = [];
      let dataToSave = {
        start_time: "",
        end_time: "",
        days: "",
        duration: "",
        quotas: 1,
        schedule_type_id: 2,
        agency_id: await getCurrentId(),
      };
      if (updateConfig.value != false) {
        url = process.env.VUE_APP_API_URL + "/api/schedules/agencies/" + idConfig.value;
        data.days.forEach((day: number) => {
          const selectDay = days.value.filter((d) => d.id == day);
          if (selectDay) {
            selectDay[0]["active"] = 1;
            configDays.push(selectDay[0]);
          }
        });
        if (typeof data.appointmenttime === "object") {
          dataToSave.duration = data.appointmenttime.value;
        } else {
          dataToSave.duration = data.appointmenttime;
        }
        dataToSave.days = configDays;
        dataToSave.start_time = data.start_time;
        dataToSave.end_time = data.end_time;
        dataToSave.quotas = data.quotas;
        dataToSave["id"] = idConfig.value;
      } else {
        data.days.forEach((day: number) => {
          days.value[day]["active"] = 1;
          configDays.push(days.value[day]);
        });
        dataToSave = {
          start_time: data.start_time,
          end_time: data.end_time,
          days: configDays,
          duration: data.appointmenttime,
          agency_id: await getCurrentId(),
          quotas: data.quotas,
          schedule_type_id: 2,
        };
      }
      await sendrequest(url, dataToSave, formEl);
    } else {
      console.log("error submit!", fields);
    }
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
  emit("closeModal");
};

const getConfig = async (idAgency = 0) => {
  const agencia: any = await localStorage.getItem("agencyIdSelected");
  let url = "api/citas/get-config/2/" + agencia;
  if(idAgency > 0){
    url = "api/citas/get-config/2/" + idAgency;
  }
  ApiService.get(url)
    .then((result) => {
      if (result.data.success) {
        let response = result.data.data;
        if (Object.values(response).length > 0) {
          ruleForm.start_time = response.start_time;
          ruleForm.end_time = response.end_time;
          const config = eval(response.days);
          let aid: any = [];
          if (config.length > 0) {
            config.forEach((e: any) => {
              if (typeof e === "object") {
                aid.push(e["id"]);
              } else {
                aid.push(e.id);
              }
            });
          }
          ruleForm.days = aid;
          const duraction = appointmenttime_options.filter(
            (o) => o.value == response.duration
          );
          if (duraction) {
            ruleForm.appointmenttime = duraction[0];
          } else {
            ruleForm.appointmenttime = {
              value: "30",
              label: "30 minutos",
            };
          }
          updateConfig.value = true;
          idConfig.value = response.id;
          ruleForm.quotas = response.quotas;
        }
      }
    })
    .catch(({ response }) => {
      console.log(response);
    });
};

onMounted(async () => {
  getConfig();
});

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "ruleFormRef",
    ref: ruleFormRef,
    model: ruleForm,
    rules: rules,
    "label-position": "top",
    class: "demo-ruleForm",
    size: formSize.value
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_form_item, {
        prop: "days",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox_group, {
            modelValue: ruleForm.days,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.days) = $event)),
            fill: "#0860f0",
            border: "",
            name: "days",
            size: "large"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day) => {
                return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                  key: day.day,
                  label: day.id,
                  border: "",
                  name: "days"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(day.label), 1)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_el_form_item, {
            prop: "start_time",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_time_select, {
                class: "w-100",
                placeholder: "Hora de inicio",
                effect: "dark",
                size: "large",
                "value-format": "HH:mm",
                format: "HH:mm",
                start: "08:00",
                end: "22:00",
                modelValue: ruleForm.start_time,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.start_time) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_el_form_item, {
            prop: "end_time",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_time_select, {
                class: "w-100",
                placeholder: "Hora de cierre",
                effect: "dark",
                size: "large",
                "value-format": "HH:mm",
                format: "HH:mm",
                start: "08:30",
                end: "22:30",
                modelValue: ruleForm.end_time,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.end_time) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_el_form_item, {
                  prop: "appointmenttime",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      name: "appointmenttime_options",
                      modelValue: ruleForm.appointmenttime,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.appointmenttime) = $event)),
                      placeholder: "Select",
                      effect: "dark",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(appointmenttime_options, (item) => {
                          return _createVNode(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value,
                            disabled: item.disabled
                          }, null, 8, ["label", "value", "disabled"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_el_form_item, {
                  prop: "quotas",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: ruleForm.quotas,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.quotas) = $event)),
                      min: 1,
                      size: "large",
                      class: "w-100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            color: "#ffffff",
            class: "btn btn-lg btn-secondary me-3",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (resetForm(ruleFormRef.value)))
          }, _hoisted_14)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            ref_key: "btnCreateConfigurationSchule",
            ref: btnCreateConfigurationSchule,
            class: "btn btn-lg btn-primary",
            id: "kt_button_1",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (submitForm(ruleFormRef.value)))
          }, _hoisted_17, 512)
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules", "size"]))
}
}

})